var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addProjectRoot" }, [
    _c("div", { staticClass: "title" }, [_vm._v("Add New Project")]),
    _vm._v(" "),
    _c("div", [_vm._v("Project Name:")]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.projectName,
            expression: "projectName"
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.projectName },
        on: {
          keypress: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.Add($event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.projectName = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "buttonRow" }, [
      _c("input", {
        attrs: { type: "button", value: "Add Project" },
        on: { click: _vm.Add }
      }),
      _vm._v(" "),
      _c("input", {
        ref: "cancelBtn",
        attrs: { type: "button", value: "Cancel" },
        on: { click: _vm.Cancel }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }